"use strict";

exports.__esModule = true;
var _ComboChart = require("./ComboChart");
Object.keys(_ComboChart).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ComboChart[key]) return;
  exports[key] = _ComboChart[key];
});